/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MatchedBy = {
    id: string
    type: MatchedBy.type;
    value: string;
};

export namespace MatchedBy {

    export enum type {
        SKU = 'SKU',
        NAME = 'NAME',
        AI = 'AI',
    }


}

